<template>
  <div style="clear: both">
    <v-autocomplete
      :model-value="modelValue"
      :label="$t('Change_Category')"
      :items="items"
      item-title="name"
      :rules="changeCategoryRules"
      :error-messages="modelValue && modelValue.length > 0 ? null : ' '"
      item-value="_id"
      variant="underlined"
      :filter="customFilter"
      :readonly="readonly"
      v-on:update:model-value="updateValue"
      density="comfortable"
      dense
      :placeholder="this.$t('Rule_Required_ChangeCategory')"
      persistent-placeholder
    ></v-autocomplete>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
export default {
  emits: ['change', 'update:modelValue'],
  props: {
    items: {
      type: Array
    },
    modelValue: {
      type: String,
      default: null
    },
    roles: {
      type: Array,
      default: null
    },
    previousFormStatus: {
      type: Object
    },
    moc: {
      type: Object
    }
  },
  computed: {
    readonly: function () {
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.NEW].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.DRAFT].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.SUBMITTED].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return true
          }
          break
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
          if (this.moc.history.some((e) => e.status.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value)) {
            return true
          }

          if (
            (this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value) &&
            (this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          break
        default:
          return true
      }
      return true
    },
    changeCategoryRules() {
      return [(v) => !!v || this.$t('Rule_Required_ChangeCategory')]
    }
  },
  methods: {
    updateValue: function (value) {
      // this.$emit('input', value)
      this.$emit('update:modelValue', value)
      this.$emit('change', value)
    },
    valueChange: function (value) {
      this.$emit('change', value)
    },
    customFilter(item, queryText, itemText) {
      let textOne = itemText.toLowerCase()
      let searchText = queryText.toLowerCase()

      return textOne.toLowerCase().indexOf(searchText) === 0
    }
  }
}
</script>

<style scoped></style>
